enum WorkSafeBcReturnToWorkTimeSpan {
    CurrentlyAtWork = 1,
    OneToSixDays,
    SevenToThirteenDays,
    FourteenToTwentyDays,
    GreaterThan20Days
}

export { WorkSafeBcReturnToWorkTimeSpan };
